var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedInIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 7,
    fill: "#2878B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8008 28.0049V35.4511H33.442V28.4589C33.442 26.7336 32.8064 25.5531 31.2627 25.5531C30.0822 25.5531 29.3557 26.3704 29.0833 27.0968C28.9925 27.3692 28.9017 27.7325 28.9017 28.1865V35.4511H24.5429C24.5429 35.4511 24.6337 23.6461 24.5429 22.4656H28.9017V24.2818C29.4465 23.3737 30.5362 22.1024 32.8064 22.1024C35.6214 22.1024 37.8008 24.0094 37.8008 28.0049ZM20.0026 16.2C18.5497 16.2 17.5508 17.1988 17.5508 18.4701C17.5508 19.7414 18.4589 20.7403 19.9118 20.7403C21.4555 20.7403 22.3636 19.7414 22.3636 18.4701C22.4544 17.108 21.5463 16.2 20.0026 16.2ZM17.8232 35.4511H22.1819V22.4656H17.8232V35.4511Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInIcon);
export default __webpack_public_path__ + "static/media/linked-in-icon.33163e9e004944d3c52add6f5fa5ef74.svg";
export { ForwardRef as ReactComponent };